import { useSyncExternalStore } from 'react'
import {
  captureRequestScope,
  readRequestScopeGeneration,
  subscribeRequestScope,
} from '@/lib/api/request-scope'

let snapshot: ReturnType<typeof captureRequestScope> | undefined

function readSnapshot() {
  const generation = readRequestScopeGeneration()
  if (!snapshot || snapshot.generation !== generation)
    snapshot = captureRequestScope()
  return snapshot
}

/** Keep rendered controls bound to their login and workspace, including A → B → A. */
export function useRequestScope() {
  return useSyncExternalStore(subscribeRequestScope, readSnapshot, readSnapshot)
}
